import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import EftWireTransferCardsUI from '@src/pages/shared/EftWireTransferCardsUI';
import PayWithEFTHavale from '@src/pages/ticketRestaurant/paymentModals/payWithEFTHavale/payWithEFTHavale';

const EftWireTransferCards = ({ finishPage, type }) => {
  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const pay = async () => {
    setIsModalOpen(true);
  };

  const payLater = async () => {
    setIsModalOpen(false);
    await window.paymentLater();
  };

  return (
    <>
      <EftWireTransferCardsUI finishPage={finishPage} type={type} onContinue={pay} />
      {isModalOpen && (
        <PayWithEFTHavale
          orderDate={
            type === 'card' ? currentCardOrder?.cardActivationDate : currentLoadBalance?.activationDate
          }
          paymentAction={payLater}
          modalAction={setIsModalOpen}
        />
      )}
    </>
  );
};

export default EftWireTransferCards;
